<template>
  <div
    v-if="languages.length > 1"
    :class="{ 'language-switcher': true, 'no-margin': noMargin }">
    <div
      @click.prevent.stop="showDropdown()"
      class="language-switcher-current">
      <icon
        size="m"
        :name="currentLanguageCode"
        :title="currentLanguageCode" />
    </div>

    <div
      v-if="dropdownVisible"
      class="language-switcher-dropdown">
      <div
        v-for="(langData, index) of languages"
        class="language-switcher-dropdown-item"
        :key="'language-switcher-dropdown-item-' + index"
        @click.prevent.stop="changeCurrentLanguage(langData.lang)">
        <icon
          size="m"
          :name="langData.lang"
          :title="langData.lang" />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'language-switcher',
  props: {
    relatedTo: {
      required: true
    },
    noMargin: {
      default: false
    }
  },
  data: function () {
    return {
      languages: [],
      currentLanguage: '',
      dropdownVisible: false
    };
  },
  computed: {
    currentLanguageCode () {
      if (this.currentLanguage === '') {
        return this.languages.filter(lang => lang.is_default)[0].lang;
      }

      return this.languages.filter(lang => lang.lang === this.currentLanguage)[0].lang;
    }
  },
  mounted () {
    if (this.$store.state.config.user.id) {
      this.loadLanguages();
    }

    this.$bus.$on('configuration-loaded', this.loadLanguages);
    this.$bus.$on('body-clicked', this.hideDropdown);
  },
  methods: {
    loadLanguages () {
      if (!this.$store.state.config.company.multilang) {
        return;
      }

      this.languages = JSON.parse(JSON.stringify(this.$store.state.config.languages));
      this.currentLanguage = this.languages.filter(lang => lang.is_default)[0].lang;
    },
    changeCurrentLanguage (langCode) {
      this.currentLanguage = langCode;
      this.$bus.$emit('change-field-language', this.relatedTo, this.currentLanguage);
      this.hideDropdown();
    },
    showDropdown () {
      this.$bus.$emit('body-clicked');

      setTimeout(() => {
        this.dropdownVisible = true;
      }, 0);
    },
    hideDropdown () {
      this.dropdownVisible = false;
    },
    setLanguage (langCode) {
      this.currentLanguage = langCode;
    }
  },
  beforeDestroy () {
    this.$bus.$off('configuration-loaded', this.loadLanguages);
    this.$bus.$off('body-clicked', this.hideDropdown);
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/scss/variables.scss';

.language-switcher {
  cursor: pointer;
  margin-left: 1rem;
  position: relative;

  &.no-margin {
    margin-left: 0;
  }

  &-current {
    align-items: center;
    border: 1px solid $color-border;
    border-radius: $border-radius-small;
    display: flex;
    height: 38px;
    justify-content: center;
    width: 38px;

    .icon {
      border: 1px solid $color-border-light;
      border-radius: 50%;
    }
  }

  &-dropdown {
    background: $color-light;
    border: 1px solid $color-border;
    border-radius: $border-radius-small;
    position: absolute;
    top: 40px;
    width: 38px;
    z-index: 2;

    &-item {
      align-items: center;
      border-top: 1px solid $color-border;
      display: flex;
      height: 38px;
      justify-content: center;
      width: 100%;

      &:hover {
        background: $color-bg-light;
      }

      &:first-child {
        border-top: none;
      }

      .icon {
        border: 1px solid $color-border-light;
        border-radius: 50%;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/common/LanguageSwitcher.vue